import { useBrand, useFlow } from '@edreamsodigeo/frontend-core';

const defaultLandingPageUrl = {
  ED: 'https://www.edreams.com/app/',
  OP: 'https://www.opodo.com/mobile-app/',
  GO: 'https://www.govoyages.com/application-voyage/',
  TR: 'https://www.travellink.com/app/',
};
const appBrands = {
  ED: 'edreams',
  OP: 'opodo',
  GO: 'govoyages',
  TR: 'travellink',
};
const appProtocolBrands = {
  ED: 'ed-app',
  OP: 'op-app',
  GO: 'go-app',
  TR: 'tl-app',
};
const appIdentifierBrands = {
  ED: 'p425',
  OP: 'RnQA',
  GO: '9tvq',
  TR: '6W7x',
};

function useLandingPageDesktop(landingUrl) {
  const brand = useBrand();
  const defaultUrl = defaultLandingPageUrl[brand];
  let url = '';
  try {
    url = new URL(landingUrl).href || defaultUrl;
  } catch (e) {
    url = defaultUrl;
  }

  return url;
}

function useLandingPageMobile(landingUrl, id, email) {
  const brand = useBrand();
  const appBrandName = appBrands[brand];
  const appProtocolName = appProtocolBrands[brand];
  const appBrandIdentifier = appIdentifierBrands[brand];
  const defaultUrl = defaultLandingPageUrl[brand];

  let url = '';
  try {
    const uId = id;
    const uEmail = btoa(email);
    const app_argument = `pid=MSITE&af_adset=PriceFreeze&af_ad=PriceFreeze_Confirmation_Page`;
    const afWebDp = encodeURIComponent(`${landingUrl}`);
    const afDp = encodeURIComponent(
      `${appProtocolName}://trips/${uId}?enc_mail=${uEmail}`
    );
    const appUrl = `https://${appBrandName}.onelink.me/${appBrandIdentifier}?${app_argument}&is_retargeting=true&af_web_dp=${afWebDp}&af_dp=${afDp}`;
    url = new URL(appUrl).href || defaultUrl;
  } catch (e) {
    url = defaultUrl;
  }
  return url;
}

export function useOpenAppDeepLink(landingUrl, id, email) {
  const downloadPageDesktop = useLandingPageDesktop(landingUrl);
  const downloadPageMobile = useLandingPageMobile(landingUrl, id, email);
  return useFlow() === 'mobile' ? downloadPageMobile : downloadPageDesktop;
}
